import {
    defineStore
  } from 'pinia'
//   const baseURL = eval('embServerURL'); //"http://embapi.ideali.club"; //
//   const baseIconsURL = eval('embBaseIconsURL'); //"https://embgift.myshopify.com/cdn/shop/t/5/assets"; //
  //const baseURL='https://localhost:7040';
  
  
  export const userStore = defineStore('userStore', {
    state: () => {
      return {
        userDesigns: {},
    }
},
// actions: {

// },
persist: true,
}
);